import { z } from 'zod';

export const backgroundJobSchema = z.object({
  id: z.string(),
  type: z.string(),
  status: z.string(),
  data: z.unknown().nullable().optional(),
  agencyId: z.string(),
  clientId: z.string(),
  userId: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type BackgroundJobSchema = z.infer<typeof backgroundJobSchema>;
